// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/ImagePicker.css
// module id = 1780
// module chunks = 0